import FilterBar from './filterBar'

export default FilterBar
